<template>
  <div>
    <base-dialog :show-dialog="true" :width="800">
      <template v-slot:body>
        <v-card dark>
          <v-card-title>
            <div>
              <span class="font-weight-bold text-subtitle-1"
                >Registrar Condição de Pagamento</span
              >
              <span class="font-weight-thin text-subtitle-2 ml-4">(ALT+R)</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form v-model="formValid" ref="form">
              <v-row>
                <v-col cols="12" sm="4" md="2">
                  <v-text-field
                    label="Código"
                    placeholder="Digite o código"
                    v-model="form.codigo"
                    class="text-caption"
                    dark
                    dense
                    outlined
                    :rules="formRules.codigoRules"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Nome"
                    placeholder="Ex NOME 0 30 60 90"
                    class="text-caption"
                    v-model="form.nome"
                    dark
                    dense
                    outlined
                    :rules="formRules.nomeRules"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <c-input
                    v-model.number="form.percentualAcrescimo"
                    label="% acréscimo"
                    placeholder="Percentual acréscimo"
                    class="text-caption"
                    :maxLength="11"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <div class="rounded text secondary">
                    <span class="ml-2">Tabela Price</span>
                    <v-radio-group
                      v-model="form.tipoPercentual"
                      height="0.05vh"
                      dense
                      row
                    >
                      <v-radio
                        v-for="option in optionList"
                        :key="option.value"
                        :label="option.text"
                        :value="option.value"
                        dense
                        class="customClass"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="form.cts"
                    :items="defaultCTsList"
                    hint="CTS"
                    placeholder="CTS"
                    class="text-caption"
                    clearable
                    persistent-hint
                    dense
                    multiple
                    outlined
                    dark
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ form.cts.length - 1 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <c-select
                    item-text="DESCRICAO"
                    item-value="CODIGO"
                    :lista="planoContaList"
                    rotulo="Conta"
                    :item.sync="form.conta"
                    v-model="form.conta"
                    @searchinput="searchAccount($event)"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <form-buttons @submitForm="submitForm()" @goBack="goBack()" />
        </v-card>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInput from '@/components/shared/base-input/BaseInput.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: { BaseDialog, cSelect, cInput, FormButtons },
  data: () => {
    return {
      timer: null,
      formValid: false,
      isUpdate: false,
      optionList: [
        { text: 'Sim', value: 'S' },
        { text: 'Não', value: 'N' },
      ],
      planoContaList: [],
      formRules: {
        codigoRules: [
          (v) => !!v || 'Este campo é obrigatório.',
          (v) => v.length <= 6 || 'Máximo 6 caracteres',
        ],
        nomeRules: [
          (v) => !!v || 'Este campo é obrigatório.',
          (v) => v.length <= 50 || 'Máximo 50 caracteres',
        ],
      },
      form: {
        codigo: '',
        percAVista: '',
        nome: '',
        numeroParcelas: '',
        intervaloVctos: '',
        vistaPrazo: '',
        percentualAcrescimo: '',
        codigoUsuario: '',
        tipoPercentual: '',
        cts: [],
        conta: {
          CODIGO: '',
          NOME: '',
        },
      },
    }
  },
  computed: {
    ...mapState('paymentConditionsModule', [
      'paymentCondition',
      'defaultCTsList',
    ]),
    ...mapState('authModule', ['authUser']),
    ...mapGetters({
      accountList: 'accountsModule/getComboBoxAccountList',
    }),
  },
  methods: {
    ...mapActions({
      insertPaymentConditionAPI:
        'paymentConditionsModule/insertPaymentConditionAPI',
      updatePaymentConditionAPI:
        'paymentConditionsModule/updatePaymentConditionAPI',
      getPaymentConditionAPI: 'paymentConditionsModule/getPaymentConditionAPI',
      getValidCTs: 'paymentConditionsModule/getValidCTs',
      getAccounts: 'accountsModule/getAccounts',
      setShowLoadingDialog : 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage'
    }),

    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Corrija os campos em vermelho');
        return
      }

      try {
        this.setShowLoadingDialog(true);
        this.setLoadingDialogMessage('Enviando Registro para o Sistema.');
        let response
        if (this.isUpdate)
          response = await this.updatePaymentConditionAPI({
            data: { ...this.transformObject() },
            id: this.$route.params.id,
          })
        else
          response = await this.insertPaymentConditionAPI({
            ...this.transformObject(),
          })
        this.$toasted.success(response);
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      } finally {
        this.setShowLoadingDialog(false);
      }
    },

    transformObject() {
      let newObj = {}

      if (this.form.conta.NOME === '') this.form.conta.CODIGO = ''

      Object.keys(this.form).forEach((key) => {
        newObj[key.toUpperCase()] = this.form[key]
      })

      let newCts = ''
      this.form.cts.forEach((ct, index) => {
        newCts += index == this.form.cts.length - 1 ? `${ct}` : `${ct},`
      })
      newObj.CTS = newCts
      console.log(newObj, JSON.stringify(newObj))
      return newObj
    },

    goBack() {
      this.$router.push({ name: 'paymentConditions' })
    },

    async mountData() {
      try {
        // recuperar os CTS padrão do sistema e possíveis flags da filial, foi substituido os CTS que estavam em ctsList
        if (this.defaultCTsList.length <= 0) await this.getValidCTs()

        if (this.$route.params && this.$route.params.id) {
          this.isUpdate = true

          await this.getPaymentConditionAPI(this.$route.params.id)
          this.form.codigo = this.paymentCondition.CODIGO
          this.form.codigoUsuario =
            this.paymentCondition.CODIGOUSUARIO ?? this.authUser.CODIGO
          this.form.conta.CODIGO = this.paymentCondition.conta
            ? this.paymentCondition.conta.CODIGO
            : ''
          this.form.conta.NOME = this.paymentCondition.conta
            ? this.paymentCondition.conta.NOME
            : ''
          this.form.intervaloVctos = this.paymentCondition.INTERVALOVCTOS
          this.form.nome = this.paymentCondition.NOME
          this.form.numeroParcelas = this.paymentCondition.NUMEROPARCELAS
          this.form.percAVista = this.paymentCondition.PERCAVISTA
          this.form.percentualAcrescimo = this.paymentCondition.PERCENTUALACRESCIMO
          this.form.tipoPercentual = this.paymentCondition.TIPOPERCENTUAL
          this.form.vistaPrazo = this.paymentCondition.VISTAPRAZO ?? 'N'

          if (this.paymentCondition.CTS) {
            let ctsArray = this.paymentCondition.CTS.split(',')
            ctsArray.forEach((ct) => {
              if (ct.endsWith(',')) ct = ct.substring(0, ct.length - 1)
              if (ct != '') this.form.cts.push(ct)
            })
          }
        } else {
          this.form.codigoUsuario = this.authUser.CODIGO
        }
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      }
    },

    searchAccount($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event.target.value ?? null

          if (!param || param.trim().length <= 0) return

          param = param
            .trim()
            .split('-')[0]
            .trim()

          let payload = { page: 1, hibrido: param }

          if (!this.form.conta || parseInt(param) !== this.form.conta.CODIGO) {
            this.getDados(payload)
          }
        }, 600)
      } catch (error) {
        console.log('erro searchCity', error)
      }
    },

    async getDados(value) {
      try {
        await this.getAccounts(value)
        this.planoContaList = this.accountList
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      }
    },
  },
  mounted() {
    this.mountData()
  },
}
</script>

<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
